module.exports = __webpack_public_path__ + "static/img/成二-廖進吉.97fa562.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/成二-廖進吉.jpg
// module id = ZxnA
// module chunks = 1